import styled from 'styled-components';
export var LikeContainer = styled.span.withConfig({
  displayName: "partials__LikeContainer",
  componentId: "sc-v3dbia-0"
})(["display:block;"]);
export var HeartAction = styled.div.withConfig({
  displayName: "partials__HeartAction",
  componentId: "sc-v3dbia-1"
})(["display:inline;cursor:pointer;svg{fill:", ";stroke:", ";}"], function (_ref) {
  var theme = _ref.theme,
    active = _ref.active;
  return active ? theme.colors.secondaryD : '#fff';
}, function (_ref2) {
  var theme = _ref2.theme,
    active = _ref2.active;
  return active ? theme.colors.secondaryD : theme.colors.font;
});